
import {observable} from "mobx";
import {StoreBase, StoreDataType} from "shared/utilities/Store/StoreBase";
import {PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {PRControlTypes} from "../PRControlFactory";



export class IconData extends StoreBase{
    Label:string;
    Value:string;
    Font:string;

    protected LoadDefaultValues() {
        this.Label='';
        this.Value='';
        this.Font='';
    }

}


export class IconControlOptions extends PDFControlBaseOptions{
    @observable
    Type:string;
    @StoreDataType(IconData)
    IconData:IconData;
    IconStyle:'basic'|'round'|'square';
    FontSize:string;
    Color:string;
    OuterHeight:number;
    OuterWidth:number;
    Data:any;

    protected LoadDefaultValues() {
        super.LoadDefaultValues();
        this.Type=PRControlTypes [PRControlTypes.Icon];
        this.IconData=new IconData().Merge();
        this.IconStyle="basic";
        this.FontSize='30px';
        this.Color='black';
        this.OuterWidth=0;
        this.OuterHeight=0;
        this.Data='';
        this.HideFromTemplateDesigner=true;
    }
}



